module.exports = __webpack_public_path__ + "static/media/near_capacity.5a45b545.svg";